export default "__VITE_ASSET__CIeiEI4T__"